import React from 'react';
import {LauncherComponentBase} from '../base-components/launcher-component-base';
import {observer} from 'mobx-react';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import CopyIcon from '@material-ui/icons/FileCopy';
import Tooltip from '@material-ui/core/Tooltip'
import copyToClipboard from 'copy-to-clipboard';

interface InputWithCopyToClipboardProps {
    label: string;
    value: string;
}
const InputWithCopyToClipboard : React.FC<InputWithCopyToClipboardProps> = (props: InputWithCopyToClipboardProps) => {
    return (
        <div style={{marginTop: '20px'}}>
            <TextField fullWidth label={props.label} value={props.value} InputProps={{
                startAdornment: (<InputAdornment position='start'>
                                    <Tooltip title='Copy to clipboard'>
                                        <IconButton onClick={() => copyToClipboard(props.value)} >
                                            <CopyIcon/>
                                        </IconButton>
                                    </Tooltip>
                                 </InputAdornment>)
            }} />
        </div>
    );
};

@observer
export class LauncherUrlsBuilderComponent extends LauncherComponentBase<{}> {
    render() {

        return (
            <div style={{margin:'10px'}}>
                <h1>URLs builder</h1>
                <Divider/>
                <div style={{marginTop:'10px'}}>
                    <InputWithCopyToClipboard label='Launcher URL' value={this.services.configsStorage.launcherUrl}/>
                    <InputWithCopyToClipboard label='Client URL' value={this.services.configsStorage.clientUrl}/>
                </div>
            </div>
        );

    }
}